module.exports = __webpack_public_path__ + "img/Startup Idea.7fc8a3df.svg";